export enum Origin {
  USER = 'user',
  PUBSUB = 'pubsub',
  SIGNATURE = 'signature',
  CRON = 'cron',
  INTENT_CRON = 'intent-cron',
  ND = 'not-defined',
}
